module.exports = __webpack_public_path__ + "app/images/34822_Abbott_Site_Beelden_Header_DEF_evenementen_1920x692_4.jpg";